import React, { FC } from 'react';
import ReactSelect, { Props } from 'react-select';
import { StylesConfig } from 'react-select/src/styles';

export type StateSelection = {
  label: string;
  value: string;
};

export const UsStateSelect: FC<Props<StateSelection, false>> = (props) => (
  <ReactSelect
    {...props}
    styles={styles}
    options={stateList.map((s) => ({
      value: s.value,
      label: s.value,
    }))}
  />
);

export const stateList = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District Of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

const styles: StylesConfig<StateSelection, false> = {
  control: (base) => ({
    ...base,
    borderRadius: '0px',
    border: '1px solid #93cac9',
    color: 'var(--dark-indigo)',
    backgroundColor: 'white',
    padding: '0px',
    minHeight: '30px',
  }),
  input: (base) => ({
    ...base,
    height: '26px',
    maxHeight: '26px',
    margin: '0px',
    paddingLeft: '0.5em',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '2px',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '2px 0px',
  }),
  placeholder: (base) => ({
    ...base,
  }),
  singleValue: (base) => {
    return {
      ...base,
      top: '60%',
      paddingLeft: '0.5em',
    };
  },
};
